<div class="spinner" *ngIf="isLoading$">
  <div class="spinner-in">
    <div class="spinner-border text-light"></div>
  </div>
</div>
